var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Button.module.scss';
import cn from 'classnames';
export const MatchButton = (props) => {
    const { label, variant = 'primary', className, icon } = props, rest = __rest(props, ["label", "variant", "className", "icon"]);
    return (_jsxs("button", Object.assign({}, rest, { className: cn(styles.ButtonContainer, {
            [styles.secondary]: variant === 'secondary',
            [styles.outline]: variant === 'outline',
        }, className) }, { children: [icon && icon, _jsx("label", Object.assign({ className: styles.label }, { children: label }))] })));
};
